module.exports = __webpack_public_path__ + "static/the-power-of-productivity-f11a08edf19aa956ac81c08d8d886566.jpg";